module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_0.ea343e3a.png";